import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { projects, contact } from './data/siteData.js'
import { loadTextures } from './data/textures.js'
import { modelLoader, targets, bubbles, titles, objectsScale, squares, board} from './objects/room.js'
import { createParticles, particlesMaterial } from './objects/particles.js'
import { dataStickers, creatingStickers, createStickers, removeSticker } from './objects/createStickers.js'
import { playMusic, sound, music} from './audio/audio.js'
import { createNote, dataNote } from './objects/createNote.js'
import { videoTv } from './data/videoTexture.js'

import gsap from 'gsap'

//dom
const canvas = document.querySelector('canvas.webgl')
const buttonBack = document.querySelector('button.buttonBack')
const infoBox= document.querySelector('div.infoBox')
const descriptionBox = document.querySelector('p.descriptionBox')
const tagsBox = document.querySelector('p.tagsBox')
const musicDataBox = document.querySelector('div.musicDataBox')
const buttonEnter = document.querySelector('button.buttonEnter')
const startBox = document.querySelector('div.startBox')
const loadingTex = document.querySelector('p.loadingText')
const buttonChange =  document.querySelector('button.buttonChange')
const descriptionMusic = document.querySelector('p.descriptionMusic')
const buttonBox = document.querySelector('div.buttonBox')

//isTouchdevice?
const isTouchDevice = window.matchMedia("(pointer: coarse)").matches 
  || 'ontouchstart' in window


// //loaderManager
const loadingManager = new THREE.LoadingManager(
    ()=>{
        loadingTex.classList.add('fade')
        setTimeout(()=>{
            loadingTex.textContent = 'Ready! ¡puedes entrar!'
            loadingTex.classList.remove('fade')
            buttonEnter.classList.add('buttonEnterActive')
        }, 300)
    }
)

//enter 
let started = false

buttonEnter.addEventListener('click', ()=>{
    if (started) return
    started = true

    videoTv.play()  //play video

    //sound
    objectsScale.radio.add(sound)
    sound.play()


    //hide buttonEnter and loadingText
    buttonEnter.style.display = 'none'
    loadingTex.style.display = 'none'

    tick() //start loop

    buttonBox.style.display = 'flex'
    requestAnimationFrame(() => {
        startBox.style.opacity = 0;
         setTimeout(() => {
            startBox.style.display = 'none';
        }, 2000)
    })
})

// Scene
const scene = new THREE.Scene()

//textures
const {stickersMaps, note, groupDefault, groupSecond} = loadTextures(loadingManager)

//model
const materials = modelLoader(scene, loadingManager, groupDefault)

//updateMaterials 
const groups = ['groupOne', 'groupTwo', 'groupThree', 'groupFour', 'groupFive']
let changeMaterials = false 

const change = () =>{
    changeMaterials = !changeMaterials
    
    //maps
    for(const key of groups){
        materials[key].map = changeMaterials ? groupSecond[`${key}Second`] : groupDefault[`${key}Default`]
        materials[key].map.needsUpdate = true
    }

    //music
    const buffer = changeMaterials ? music['musicTwo'] : music['musicOne']
    sound.stop()
    sound.setBuffer(buffer)
    sound.play()

    //dataMusic
    descriptionMusic.innerHTML = changeMaterials ? 
    'Music — “Lofi Type Beat - Late Night Vibes” by Nikoo <br> (Pixabay License)' :
    'Music — “Pass Love Along” by Vernon Maytone <br> Courtesy of Brotheration Records (Pixabay License)' 
}

buttonChange.addEventListener('click', ()=>{
    change()
    const newClass = changeMaterials ? '#121212d7' : '#f3e9bf'
    buttonChange.style.backgroundColor = newClass
})

//sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2)
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    sizes.pixelRatio = Math.min(window.devicePixelRatio, 2)
    
    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(sizes.pixelRatio)
})

//camera
const camera = new THREE.PerspectiveCamera(24, sizes.width / sizes.height, 0.1, 100)
const xCamera = isTouchDevice ? 10 : 6.06
const zCamera = isTouchDevice ? 10 : 5.75
camera.position.set(xCamera, 3.362, zCamera)
scene.add(camera)

//renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
createParticles(scene, renderer)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 1.1, 0)
controls.enableDamping = true
controls.minPolarAngle = Math.PI / 4
controls.maxPolarAngle = Math.PI / 1.8
controls.minAzimuthAngle = Math.PI / 14
controls.maxAzimuthAngle = Math.PI / 2
controls.minDistance = 1
controls.maxDistance = 17

let isDragging
controls.addEventListener('start', ()=>{
    isDragging = true
})

controls.addEventListener('end', ()=>{
    isDragging = false
})

//mouse
const raycaster = new THREE.Raycaster()
const pointer = new THREE.Vector2()
const mousePosition = {x: 0, y :0}

window.addEventListener('pointermove', (event) =>{
    mousePosition.x = event.clientX
    mousePosition.y = event.clientY

    const canvasRect = renderer.domElement.getBoundingClientRect()

    pointer.x = ((event.clientX - canvasRect.left) / canvasRect.width) * 2 - 1
    pointer.y = -((event.clientY - canvasRect.top) / canvasRect.height) * 2 + 1
})


//eventClick

const actions = {
    stickerGmail: ()=> window.location.href = contact.stickerGmail.url, 
    radio: () => musicDataBoxShow(),
    ...Object.fromEntries(Object.keys(projects).map(name => [name, ()=>  window.open(projects[name].url, "_blank")])),
    ...Object.fromEntries(Object.keys(contact).filter(name => name !== 'stickerGmail').map(name => [name, ()=>  window.open(contact[name].url, "_blank")])),
}

let previusTargetClick
window.addEventListener('click', ()=>{
    if(isTouchDevice) return

    if(currentIntersect){
        const objectIntersect = currentIntersect

        if(objectIntersect.userData.positionCamera){
            moveCameraToTarget(objectIntersect)
        }

        if(actions[objectIntersect.name]) actions[objectIntersect.name]()
    } 
    
})


window.addEventListener('pointerup', ()=>{
    if(!isTouchDevice) return

    raycaster.setFromCamera(pointer, camera)
    const intersects = raycaster.intersectObjects(targets)

     if(intersects.length > 0) {
        const object = intersects[0].object

        if (object.userData.scaleRaycaster && previusTargetClick !== object.name) {
            scaleObjectTarget(object)
            setTimeout(()=> {
                object.scale.set(1, 1, 1)
            }, 2000)
        }

        if(object.userData.positionCamera && previusTargetClick !== object.name){
            moveCameraToTarget(object)
        }

         if(object.userData.nameBubble){
                bubbles[object.userData.nameBubble].visible = true
                setTimeout(()=> {
                     bubbles[object.userData.nameBubble].visible = false
                }, 5000)
            }

        if (actions[object.name] && object.visible) {
            actions[object.name]()
        }

    } 
         
})

const moveCameraToTarget = (object) =>{
    const position = object.userData.positionCamera
    cameraMovement(positionCamera[position])
    previusTargetClick = object.name
}

const scaleObjectTarget = (object) =>{
      object.scale.set(object.userData.scaleRaycaster, object.userData.scaleRaycaster, object.userData.scaleRaycaster)
}

const musicDataBoxShow = ()=>{
    musicDataBox.style.opacity = '1'
        setTimeout(()=> {
            musicDataBox.style.opacity = '0'
        }, 5000)
}

createNote(scene, note)
playMusic(camera, loadingManager)

//animateCamera
const positionCamera = [
    {
        cameraPosition: {x: 6.06, y: 3.362, z: 5.75},
        controlsTargetPosition: {x: 0, y: 1.1, z: 0},
    },
    {
        cameraPosition: {x: 0.993, y: 2, z: 1.8},
        controlsTargetPosition: {x: -1.136, y: 1.66, z: 0.98},
    },
    {
        cameraPosition: {x: 0.412, y: 1, z: 0.596},
        controlsTargetPosition: {x: -0.02, y: 1, z: 0},
    }
]

const cameraActions = {
    6.06: {
        onStart: () =>{
            controls.maxDistance = 17
            controls.enablePan =  true
            controls.enableRotate = true
             buttonBack.classList.add('buttonBack')
             buttonBack.classList.remove('buttonBackActive')
            if(bubbles.bigBubbleProjects.visible){
                bubbles.bigBubbleProjects.visible = false 
               for(let title in titles){
                    titles[title].visible = false
               }
            }
            if(bubbles.bigBubbleAbout.visible) bubbles.bigBubbleAbout.visible = false 
        }, 
        onComplete: () =>{
            previusTargetClick = null
             if(creatingStickers){
                removeSticker(scene)
            }
        }
    }, 
    0.412: {
        onComplete: ()=>{
            controls.maxDistance = isTouchDevice ? 2 : 1
            controls.enableRotate = isTouchDevice ? false : true
            controls.enablePan =  isTouchDevice ?  true: false  
            bubbles.bigBubbleProjects.visible = true
            globoAnimate(bubbles.bigBubbleProjects)
            for(let title in titles){
                    titles[title].visible = true
               }
            createStickers(scene, stickersMaps) 
            buttonBack.classList.add('buttonBackActive')
        }
    }, 
    0.993: {
        onComplete: ()=>{
            controls.maxDistance = isTouchDevice ? 4 : 2
            controls.enableRotate = isTouchDevice ? false : true
            controls.enablePan =  isTouchDevice ?  true: false 
            bubbles.bigBubbleAbout.visible = true
            globoAnimate(bubbles.bigBubbleAbout)
            buttonBack.classList.add('buttonBackActive')
        }
    }
}
const cameraMovement = (positions) =>{
    controls.enabled= false

    const actions = cameraActions[positions.cameraPosition.x] 
    gsap.to(camera.position, {
        x: positions.cameraPosition.x, 
        y: positions.cameraPosition.y, 
        z: positions.cameraPosition.z,
        duration: 1.2,
        ease: 'sine.inOut', 
        onStart: actions.onStart,
        onComplete: actions.onComplete
    }), 
    gsap.to(controls.target, {
        x: positions.controlsTargetPosition.x, 
        y: positions.controlsTargetPosition.y, 
        z: positions.controlsTargetPosition.z,
        duration: 1.2,
        ease: 'sine.inOut', 
        onComplete: () => {
            controls.enabled = true
        }
    })
}

const globoAnimate = (object) =>{
    object.scale.set(0, 0, 0)
      gsap.to(object.scale, {
        x: 1,
        y: 1, 
        z: 1,
        duration: 0.5, 
        ease: 'back.out(1.5)',
      })
}

buttonBack.addEventListener('click', ()=>{
   cameraMovement(positionCamera[0])
})

const showInformation = (object) =>{
        infoBox.style.display = 'block'
        infoBox.style.top =  `${mousePosition.y - 20}px`
        descriptionBox.textContent = projects[object.name].description || 'objeto sin nombre'
        tagsBox.textContent = projects[object.name].tags 
}


//animate

const animateBoard =(elapsedTime)=>{
    board.rotation.z = Math.sin(elapsedTime * 1.2) * (Math.PI / 4)
}

const animateStickers = (deltaTime) =>{
    dataStickers.forEach((obj) =>{
            obj.meshSticker.position.y += deltaTime * obj.speed * 0.02
            obj.meshSticker.rotation.z += deltaTime * obj.speed 
            if(obj.meshSticker.position.y > 1.35){
                obj.meshSticker.position.copy(obj.startPosition)
            }
        })
}

const animateDataNote = (deltaTime) =>{
 dataNote.forEach((obj) =>{
            obj.noteMesh.position.x += deltaTime * 0.05
            obj.noteMesh.position.y += deltaTime * 0.05
            obj.noteMesh.position.z += deltaTime * 0.05
            if(obj.noteMesh.position.x > 1.13){
                obj.noteMesh.position.copy(obj.startPosition)
            }
    })
}

const animateScale = (elapsedTime) =>{
    for(let key in objectsScale){
        const object = objectsScale[key]
        object.scale.x = Math.sin(elapsedTime * object.userData.speed) * object.userData.amplitudX + object.userData.scaleBase
        object.scale.y = Math.sin(elapsedTime * object.userData.speed) * object.userData.amplitudY + object.userData.scaleBase
        object.scale.z = Math.sin(elapsedTime * object.userData.speed)  * object.userData.amplitudZ + object.userData.scaleBase
    }
}

const animateOpacity = (elapsedTime) =>{
    squares.material.opacity = 0.4 +  0.6 * (Math.sin(elapsedTime * 4) * 0.5 + 0.5)
}

let currentIntersect  = null
let currentIntersectBubble = null

const updateRaycaster = () =>{
    raycaster.setFromCamera(pointer, camera)
    const intersects = raycaster.intersectObjects(targets)

    if(intersects.length){  
        const object = intersects[0].object
        if(object.visible && object.name !== previusTargetClick){
              document.body.style.cursor = 'pointer'
             if (currentIntersect !== object){
                if(currentIntersect){
                    currentIntersect.scale.set(1, 1, 1)
                }
                if(object.userData.scaleRaycaster){
                    scaleObjectTarget(object)
                    if(object.name.includes('title')){
                        showInformation(object)
                    }
                }
                  currentIntersect = object
            }
            
            if(object.userData.nameBubble){
                document.body.style.cursor = 'default'
                currentIntersectBubble = object.userData.nameBubble
                bubbles[currentIntersectBubble].visible = true
            }
        }
    } else {
        document.body.style.cursor = 'default'
        if(currentIntersect){
            currentIntersect.scale.set(1, 1, 1)
            if(currentIntersect.name.includes('title')){
                infoBox.style.display = 'none'
            }
              currentIntersect  = null
        }
        if(currentIntersectBubble){
            bubbles[currentIntersectBubble].visible = false
            currentIntersectBubble = null
        } 
        } 
}


const clock = new THREE.Clock()
let oldElapsedtime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - oldElapsedtime
    oldElapsedtime = elapsedTime

    controls.update()

    particlesMaterial.uniforms.uTime.value += deltaTime
    materials.smoke.uniforms.uTime.value = elapsedTime

    if(objectsScale) animateScale(elapsedTime)

    if(squares) animateOpacity(elapsedTime)

    if(creatingStickers) animateStickers(deltaTime)

    animateDataNote(deltaTime)
    
    if(board) animateBoard(elapsedTime)

    if(!isDragging && !isTouchDevice) updateRaycaster()
 
    renderer.render(scene, camera)

    window.requestAnimationFrame(tick)
}

